export const FeaturesData = [
    "First features",
    "Second features",
    "Third features",
    "Fourth features",
]